import { Grid, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { theme } from 'styles/global-styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  gridDataCollection: {
    ':nth-of-type(1)': {
      boxShadow: `0px -1px 1px ${theme.palette.framework.system.charcoal}`,
    },
    ':nth-of-type(odd)': {
      backgroundColor: theme.palette.framework.system.lightGray,
    },
  },
  alternativeRow: {
    ':nth-of-type(even)': {
      backgroundColor: theme.palette.framework.system.lightGray,
    },
  },
  alternative: {
    backgroundColor: theme.palette.framework.system.lightGray,
  },
}));

export interface ICustomGridRowProps {
  singleRow?: boolean;
  gridRows: {
    labelCellSize: number;
    dataCellSize: number;
    labelCell: string;
    dataCell: string;
    alternativeRow?: boolean;
  }[];
}

export const CustomGridWithoutHeader = (gridProps: ICustomGridRowProps) => {
  const { classes, cx } = useStyles();
  const gridRowCollection = gridProps?.gridRows.map((cellInfo, cellIndex) =>
    gridProps?.singleRow ? (
      <>
        <Grid xs={6} md={cellInfo.labelCellSize} sx={{ padding: theme.spacing(1) }}
                  className={cx({ [classes.alternative]: cellInfo?.alternativeRow })}
>
          <Typography variant={'subtitle2'}>{cellInfo.labelCell}:</Typography>
        </Grid>
        <Grid xs={6} md={cellInfo.dataCellSize} sx={{ padding: theme.spacing(1) }}
                  className={cx({ [classes.alternative]: cellInfo?.alternativeRow })}
>
          {_.split(cellInfo.dataCell, '\n').length > 1 ? (
            _.split(cellInfo.dataCell, '\n').map((str, idx) => (
              <Typography variant={'body1'} key={idx}>
                {str}
              </Typography>
            ))
          ) : (
            <Typography variant={'body1'}>{cellInfo.dataCell}</Typography>
          )}
        </Grid>
      </>
    ) : (
      <Grid container className={cx(classes.alternativeRow)} key={cellIndex}>
        <Grid xs={6} md={cellInfo.labelCellSize} sx={{ padding: theme.spacing(1) }}>
          <Typography variant={'subtitle2'}>{cellInfo.labelCell}:</Typography>
        </Grid>
        <Grid xs={6} md={cellInfo.dataCellSize} sx={{ padding: theme.spacing(1) }}>
          {_.split(cellInfo.dataCell, '\n').length > 1 ? (
            _.split(cellInfo.dataCell, '\n').map((str, idx) => (
              <Typography variant={'body1'} key={idx}>
                {str}
              </Typography>
            ))
          ) : (
            <Typography variant={'body1'}>{cellInfo.dataCell}</Typography>
          )}
        </Grid>
      </Grid>
    ),
  );
  return <>{gridRowCollection}</>;
};

export interface ICustomGridHeader {
  columnHeader: string;
  columnSize: number;
  columnAlignment?: string;
  paddingLeft?: string;
  paddingRight?: string;
  columnMapping: string;
}

export interface ICustomGridProps {
  header: ICustomGridHeader[];
  rows: any[];
}

export const CustomGridWithHeader = (gridProps: ICustomGridProps) => {
  const { classes, cx } = useStyles();
  const gridHeader = gridProps?.header?.map((headerColumn, headerColumnIndex) => (
    <Grid
      key={headerColumnIndex}
      xs={6}
      md={headerColumn?.columnSize}
      sx={{
        padding: theme.spacing(1),
        textAlign: `${headerColumn?.columnAlignment ?? 'left'}`,
        ...(headerColumn?.paddingLeft && {
          paddingLeft: `${headerColumn?.paddingLeft}`,
        }),
        ...(headerColumn?.paddingRight && {
          paddingRight: `${headerColumn?.paddingRight}`,
        }),
      }}
    >
      <Typography variant={'subtitle2'}>{headerColumn?.columnHeader}</Typography>
    </Grid>
  ));
  const gridRows = gridProps.rows.map((gridRow, gridRowIndex) => {
    return (
      <Grid container key={gridRowIndex} className={cx(classes.gridDataCollection)}>
        {gridProps?.header?.map((headerColumn, headerColumnIndex) => {
          return (
            <>
              {gridRow.hasOwnProperty(headerColumn?.columnMapping) &&
                gridRow[headerColumn?.columnMapping] !== undefined && (
                  <Grid
                    key={headerColumnIndex}
                    item
                    xs={6}
                    md={headerColumn?.columnSize}
                    sx={{
                      padding: theme.spacing(1),
                      textAlign: `${headerColumn?.columnAlignment ?? 'left'}`,
                      ...(headerColumn?.paddingLeft && {
                        paddingLeft: `${headerColumn?.paddingLeft}`,
                      }),
                      ...(headerColumn?.paddingRight && {
                        paddingRight: `${headerColumn?.paddingRight}`,
                      }),
                    }}
                  >
                    {_.split(gridRow[headerColumn?.columnMapping], '\n').length > 1 ? (
                      _.split(gridRow[headerColumn?.columnMapping], '\n').map((str, ix) => (
                        <Typography variant={'body1'} key={ix}>
                          {str}
                        </Typography>
                      ))
                    ) : (
                      <Typography variant={'body1'}>{gridRow[headerColumn?.columnMapping]}</Typography>
                    )}
                  </Grid>
                )}
            </>
          );
        })}
      </Grid>
    );
  });

  return (
    <React.Fragment>
      <Grid container>{gridHeader}</Grid>
      <Grid container>{gridRows}</Grid>
    </React.Fragment>
  );
};
